import { createSelector } from 'reselect';

const adminRootSelector = (state: TReduxState) => state.root.admin;
const adminUserSelector = createSelector(adminRootSelector, (state) => state.user)

export const selectIsAdmin = createSelector(adminUserSelector, (state) => state.isAdmin)
export const selectIsAdminProfile = createSelector(adminUserSelector, (state) => state.user)